var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVoiceoverIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_347",
    "data-name": "Group 347",
    transform: "translate(-775 -611)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_23",
    "data-name": "Ellipse 23",
    cx: 20,
    cy: 20,
    r: 20,
    transform: "translate(775 611)",
    fill: "#305316"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_232",
    "data-name": "Rectangle 232",
    width: 9,
    height: 11,
    transform: "translate(790 620)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_24",
    "data-name": "Ellipse 24",
    cx: 4.5,
    cy: 4,
    rx: 4.5,
    ry: 4,
    transform: "translate(790 616)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_25",
    "data-name": "Ellipse 25",
    cx: 4.5,
    cy: 4,
    rx: 4.5,
    ry: 4,
    transform: "translate(790 627)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_26",
    "data-name": "Ellipse 26",
    transform: "translate(784 621)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.5,
    cy: 10,
    rx: 10.5,
    ry: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.5,
    cy: 10,
    rx: 9,
    ry: 8.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_233",
    "data-name": "Rectangle 233",
    width: 8,
    height: 15,
    transform: "translate(799 617)",
    fill: "#305316"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_234",
    "data-name": "Rectangle 234",
    width: 8,
    height: 15,
    transform: "translate(782 617)",
    fill: "#305316"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_235",
    "data-name": "Rectangle 235",
    width: 4,
    height: 7,
    transform: "translate(793 638)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoiceoverIcon);
export default __webpack_public_path__ + "static/media/voiceoverIcon.e1e998b4c2e5ab69f57b1ca5cfcc4078.svg";
export { ForwardRef as ReactComponent };